const state = () => {
  return {
    sc_employees: [],
    sc_employee: {},
    sc_employee_filters: {},
  }
}

export default state;
